import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppStoreProvider } from "@/store/AppStore";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import CertificatePage from "@/pages/CertificatePage";
import TimesheetPage from "@/pages/TimesheetPage";
import MasterOverview from "@/pages/master/MasterOverview";
import MasterCompanies from "@/pages/master/MasterCompanies";
import MasterCompanyDetail from "@/pages/master/MasterCompanyDetail";
import MasterReport from "@/pages/master/MasterReport";
import MasterRanking from "@/pages/master/MasterRanking";
import MasterAgenda from "@/pages/master/MasterAgenda";
import OwnerMaintenance from "@/pages/owner/OwnerMaintenance";
import OwnerAccess from "@/pages/owner/OwnerAccess";
import OwnerAgenda from "@/pages/owner/OwnerAgenda";
import OwnerNetwork from "@/pages/owner/OwnerNetwork";
import CollabAccess from "@/pages/collab/CollabAccess";
import OwnerDashboard from "@/pages/owner/OwnerDashboard";
import OwnerTeam from "@/pages/owner/OwnerTeam";
import OwnerProcesses from "@/pages/owner/OwnerProcesses";
import OwnerSales from "@/pages/owner/OwnerSales";
import OwnerRanking from "@/pages/owner/OwnerRanking";
import OwnerFeedback from "@/pages/owner/OwnerFeedback";
import OwnerGoals from "@/pages/owner/OwnerGoals";
import OwnerAttendance from "@/pages/owner/OwnerAttendance";
import CollabToday from "@/pages/collab/CollabToday";
import CollabGoals from "@/pages/collab/CollabGoals";
import CollabFeedback from "@/pages/collab/CollabFeedback";

function App() {
  return (
    <AppStoreProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/certificado" element={<CertificatePage />} />
          <Route path="/espelho-ponto" element={<TimesheetPage />} />
          <Route path="/master" element={<Shell role="master" />}>
            <Route index element={<MasterOverview />} />
            <Route path="empresas" element={<MasterCompanies />} />
            <Route path="empresas/:id" element={<MasterCompanyDetail />} />
            <Route path="relatorio" element={<MasterReport />} />
            <Route path="ranking" element={<MasterRanking />} />
            <Route path="agenda" element={<MasterAgenda />} />
          </Route>
          <Route path="/empresaria" element={<Shell role="empresaria" />}>
            <Route index element={<OwnerDashboard />} />
            <Route path="equipe" element={<OwnerTeam />} />
            <Route path="jornada" element={<OwnerAttendance />} />
            <Route path="processos" element={<OwnerProcesses />} />
            <Route path="vendas" element={<OwnerSales />} />
            <Route path="metas" element={<OwnerGoals />} />
            <Route path="ranking" element={<OwnerRanking />} />
            <Route path="feedback" element={<OwnerFeedback />} />
            <Route path="manutencao" element={<OwnerMaintenance />} />
            <Route path="acessos" element={<OwnerAccess />} />
            <Route path="agenda" element={<OwnerAgenda />} />
            <Route path="indicacoes" element={<OwnerNetwork />} />
          </Route>
          <Route path="/colaboradora" element={<Shell role="colaboradora" />}>
            <Route index element={<CollabToday />} />
            <Route path="metas" element={<CollabGoals />} />
            <Route path="feedback" element={<CollabFeedback />} />
            <Route path="acessos" element={<CollabAccess />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors offset={80} />
    </AppStoreProvider>
  );
}

export default App;
